import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { ChipModeEnum } from './chip-mode.enum';

@Component({
  selector: 'dbx-chip',
  standalone: true,
  imports: [MatIcon, MatChipSet, MatChip],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
})
export class ChipComponent {
  mode = input<ChipModeEnum>(ChipModeEnum.unknown);
  icon = input<string>('');
  protected readonly ChipModeEnum = ChipModeEnum;
}
